import React from 'react';
import { StorageService } from 'services/storage-service/StorageService';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';

interface FormContextProps {
	setError: (value: boolean) => void;
	setData: (data: any) => void;
	storage?: StorageService;
}

export const FormContext = React.createContext<FormContextProps>({
	setData: (data: any) => {
		return;
	},
	setError: (value: any) => {
		return;
	},
	storage: new StorageServiceImpl(),
});
